import { isFinite } from 'lodash'

const CurrencyCode = Object.freeze({
  EUR: 'EUR',
  SEK: 'SEK',
  BGN: 'BGN'
})

const CurrencyCodeValues = Object.values(CurrencyCode)

const currencies = [
  { code: CurrencyCode.EUR, symbol: '€' },
  { code: CurrencyCode.SEK, symbol: 'kr' },
  { code: CurrencyCode.BGN, symbol: 'Лв.' }
]

const EUR_TO_BGN_RATE = 1.95583

function currencyCodeToSymbol (currencyCode, fallback = '') {
  const definition = currencies.find(item => item.code === currencyCode)

  return definition ? definition.symbol : fallback
}

function currencySymbolToCode (currencySymbol, fallback = '') {
  const definition = currencies.find(item => item.symbol === currencySymbol)

  return definition ? definition.code : fallback
}

function isCurrencySymbol (value) {
  return currencies.findIndex(item => item.symbol === value) > -1
}

function getCurrencyCode (currency, fallback = 'N/A') {
  if (CurrencyCodeValues.includes(currency)) {
    return currency
  }

  return currencySymbolToCode(currency, fallback)
}

const bgnToEur = amount => isFinite(amount) ? amount / EUR_TO_BGN_RATE : null
const eurToBgn = amount => isFinite(amount) ? amount * EUR_TO_BGN_RATE : null

export {
  CurrencyCode,
  currencyCodeToSymbol,
  currencySymbolToCode,
  isCurrencySymbol,
  bgnToEur,
  eurToBgn,
  getCurrencyCode
}
